export const download = (fileData, name, extension) => {
    const url = window.URL.createObjectURL(new Blob([fileData]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name + '.' + extension);
    document.body.appendChild(link);
    link.click();
    link.remove();
};
